import { render, staticRenderFns } from "./UploadHistory.vue?vue&type=template&id=a681c09c"
import script from "./UploadHistory.vue?vue&type=script&lang=js"
export * from "./UploadHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports